import { createPortal } from 'react-dom';
import { RiCloseLine } from '@remixicon/react';
import {
  PERMISSIONS,
  MODULE_DISPLAY_ORDER,
  ROLE_DISPLAY_ORDER,
  getPermission,
} from '@/lib/permissions';

const RolePermissionsModal = ({ open, onClose }) => {
  if (!open) return null;

  return createPortal(
    <div
      className="fixed inset-0 z-[10000] bg-black/40 flex items-center justify-center p-4"
      onClick={onClose}
    >
      <div
        className="bg-white rounded-2xl shadow-xl w-full max-w-xl max-h-[85vh] flex flex-col"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between px-5 py-4">
          <h2 className="text-lg font-semibold text-primary-700">Role Permissions</h2>
          <button
            type="button"
            onClick={onClose}
            className="p-1 rounded-full hover:bg-gray-100 transition-colors"
          >
            <RiCloseLine className="w-5 h-5 text-gray-500" />
          </button>
        </div>

        <div className="overflow-y-auto px-5 pt-0 py-4 space-y-4">
          {ROLE_DISPLAY_ORDER.map((role) => {
            const roleMap = PERMISSIONS[role.key] || {};
            return (
              <div key={role.key} className="border border-gray-200 rounded-xl p-4">
                <h3 className="text-sm font-semibold text-gray-900 mb-3">{role.label}</h3>
                <ul className="space-y-1.5">
                  {MODULE_DISPLAY_ORDER.map((module) => {
                    const perm = roleMap[module.key] || getPermission(role.key, module.key);
                    return (
                      <li
                        key={module.key}
                        className="flex items-start justify-between gap-4 text-xs text-gray-600"
                      >
                        <span className="flex-shrink-0">{module.label}</span>
                        <span className="text-right text-gray-500">{perm.label}</span>
                      </li>
                    );
                  })}
                </ul>
              </div>
            );
          })}
        </div>
      </div>
    </div>,
    document.body
  );
};

export default RolePermissionsModal;
